import {
  Injectable
} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import {
  Observable
} from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _router: Router, private route: ActivatedRoute) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable < boolean > | Promise < boolean > | boolean {
    let userId = '';
    let isReturn = false;
    this.route.queryParams.subscribe(params => {
      ​​
      userId = params['UserId'];
      if (userId === '' || userId === undefined || userId === null) {
        let data = localStorage.getItem('randomNumber');
        if (data !== null && data !== undefined && data !== '') {
         return  isReturn = true;
        } else {
          this._router.navigate(['/auth/login/simple']);
         return isReturn = false;
        }
      } else {
       return  isReturn = true;
      }

    })


    return isReturn;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.guard.ts